import { render, staticRenderFns } from "./OnSiteMessagePopupCreate.vue?vue&type=template&id=495364e3&"
import script from "./OnSiteMessagePopupCreate.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessagePopupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports